import React from 'react'
import AdaptableProjectNote from './AdaptableProjectNote'
import './CrmShowcase.css'

const CRM_URL = 'https://crm.taskpro.fr'

const CrmShowcase = ({ onApplicationRequest }) => (
    <article className="crm-showcase-site">
        <a className="crm-window" href={CRM_URL} target="_blank" rel="noopener noreferrer" aria-label="Ouvrir le CRM AM Services">
            <div className="crm-window-bar"><i></i><i></i><i></i><span>crm.taskpro.fr</span></div>
            <div className="crm-window-body">
                <aside className="crm-demo-sidebar">
                    <div className="crm-demo-brand"><b>am</b><span>AM Services</span></div>
                    <div className="crm-demo-user"><i>VD</i><span><strong>Visiteur démo</strong><small>Session fictive</small></span></div>
                    <small>APPLICATIONS</small>
                    <b className="active">▦ TaskPro</b><b>☎ Appels</b><b>▤ Planning</b>
                    <em>? Visite guidée</em>
                </aside>
                <div className="crm-demo-content">
                    <span className="crm-demo-eyebrow">ESPACE MÉTIER · DÉMONSTRATION</span>
                    <h5>Bonjour, Visiteur 👋</h5>
                    <p>Vos outils réunis dans une interface unique.</p>
                    <div className="crm-demo-stats"><span><strong>3</strong><small>applications</small></span><span><strong>1</strong><small>espace de travail</small></span><span><strong>100 %</strong><small>données fictives</small></span></div>
                    <div className="crm-demo-apps">
                        <div className="blue"><b>▦</b><strong>TaskPro</strong><small>Suivi de production</small><em>Ouvrir →</em></div>
                        <div className="pink"><b>☎</b><strong>Appels</strong><small>Suivi des demandes</small><em>Ouvrir →</em></div>
                        <div className="green"><b>▤</b><strong>Planning</strong><small>Organisation terrain</small><em>Ouvrir →</em></div>
                    </div>
                </div>
            </div>
            <em className="crm-window-link">Explorer le CRM ↗</em>
        </a>

        <div className="crm-showcase-copy">
            <span className="crm-signature">Une réalisation AM Services</span>
            <h3>CRM AM Services</h3>
            <h4>TaskPro, les appels et le planning réunis dans un seul espace métier.</h4>
            <p>
                Ce portail centralise les applications utiles à l’équipe dans une interface commune.
                Chaque utilisateur accède rapidement au suivi de production, aux demandes clients et
                au planning, sans multiplier les connexions ni les fenêtres.
            </p>
            <ul>
                <li>Trois applications intégrées</li>
                <li>Navigation centralisée</li>
                <li>Interface adaptée aux rôles</li>
                <li>Accès direct ou nouvel onglet</li>
            </ul>
            <AdaptableProjectNote />
            <div className="crm-showcase-actions">
                <a className="crm-primary" href={CRM_URL} target="_blank" rel="noopener noreferrer">Tester la démo <span aria-hidden="true">↗</span></a>
                <button type="button" className="crm-secondary" onClick={onApplicationRequest}>Créer mon espace métier</button>
            </div>
        </div>
    </article>
)

export default CrmShowcase
